import type { JSX } from "react";
interface PercentBarProps {
  value: number;
  height?: string;
  width?: string;
  UNSAFE_className?: string;
}

export const PercentBarDeprecated = ({
  value = 0,
}: {
  value: number;
}): JSX.Element => (
  <span className="percent-bar tw-flex tw-items-center">
    <span
      className={`
        tw-block
        tw-h-[22px] tw-w-[120px] tw-overflow-hidden tw-rounded-2xl
        tw-shadow-[inset_0_0_0_1px] tw-shadow-blue-600
      `}
    >
      <span
        className={`tw-block tw-h-full tw-bg-blue-600`}
        style={{ width: `${value || 0}%` }}
      />
    </span>
    <span className="tw-ml-3 tw-block">{value}%</span>
  </span>
);

export const PercentBar = ({
  value = 0,
  height = '10px',
  width = '120px',
  UNSAFE_className = '',
}: PercentBarProps): JSX.Element => (
  <span className={`percent-bar tw-flex tw-items-center ${UNSAFE_className}`}>
    <span
      className={`
        tw-block tw-shrink-0 tw-grow tw-overflow-hidden tw-rounded-2xl tw-bg-blue-200
      `}
      style={{
        height,
        maxWidth: width,
      }}
    >
      <span
        className={`tw-block tw-h-full tw-rounded-2xl tw-bg-blue-600`}
        style={{ width: `${value || 0}%` }}
      />
    </span>
    <span className="tw-ml-4 tw-block tw-min-w-[3rem] tw-text-right">
      {value}%
    </span>
  </span>
);
